
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import formatNumber from '@/shared/filters/format-number';
import Paging from '@/shared/components/Paging.vue';
import { DATA } from '@/config/data';
import { APP_CONFIG } from '@/config/app-config';
import { PaymentRequestModel } from '@/models/payment-request';
import ListPaymentRequest from './components/ListPaymentRequest.vue';
import paymentRequestServices from '@/services/payment-request-services';
import commonService from '@/services/common-services';
import orderService from '@/services/order-service';
import depositService from '@/services/deposit-services';
import FilterBox from './components/FilterBox.vue';

@Component({
    components: {
        ListPaymentRequest,
        Loading,
        FilterBox,
        Paging
    }
})
export default class MainPaymentRequest extends Vue {
    private filterProp = {
        selectedStatus: { value: -1, name: 'Tất cả', color: '#fff' },
        searchText: ''
    };
    private pageSettings = {
      rowPerPage: 15,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listPaymentRequest: PaymentRequestModel[] = [];
    private isLoading = false;
    private chinaAddress = null;
    private numberOfOrder = 0;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get shippingMethods() {
        return DATA.shippingMethods;
    }

    private async created() {
        this.loadData();
        let result = await orderService.getSummaryPayable();
        if (result && result.status === 200) {
            this.numberOfOrder = result.data.data.NumerOrder;
        }
        result = await depositService.getSummaryPayable();
        if (result && result.status === 200) {
            this.numberOfOrder += result.data.data.NumerOrder;
        }
    }

    private async loadData() {
        this.isLoading = true;
        this.pageSettings.total = 0;
        const filters: any = this.onBuildFilter();
        const result = await paymentRequestServices.getPaymentRequest(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filters.filters, filters.quickFilters);
        this.isLoading = false;
        if (result && result.data && result.data.status === 200) {
            const tmpListPaymentRequest: PaymentRequestModel[] = [];
            this.pageSettings.total = result.data.total;

            for (const item of result.data.data) {
                const paymentRequest = new PaymentRequestModel();
                paymentRequest.id = item.ID;
                paymentRequest.uId = item.UID;
                paymentRequest.userName = item.Username;
                paymentRequest.status = item.Status;
                paymentRequest.statusDetail = DATA.requestPaymentStatus.find(x => x.value === item.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                paymentRequest.createdDate = item.CreatedDate;
                paymentRequest.createdBy = item.CreatedBy;
                paymentRequest.totalAmount = item.TotalAmount;
                paymentRequest.totalPayment = item.TotalPayment;
                paymentRequest.totalOrder = item.TotalOrder;
                paymentRequest.receiverPhone = item.ReceiverPhone;
                paymentRequest.receiverAddress = item.ReceiverAddress;
                paymentRequest.shippingMethod = item.ShippingMethod;
                paymentRequest.shippingMethodDetail = this.shippingMethods.find(x => x.value === item.ShippingMethod) || { value: -1, name: '', color: '#3b4354' };
                paymentRequest.note = item.Note;

                tmpListPaymentRequest.push(paymentRequest);
            }
            this.listPaymentRequest = tmpListPaymentRequest;
        }
    }

    private onBuildFilter() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        if (this.filterProp.searchText !== null &&
            this.filterProp.searchText !== undefined &&
            this.filterProp.searchText !== '') {
                paramsFilter.quickFilters.push({
                    column: 'ID',
                    value: this.filterProp.searchText.toUpperCase().replace('Y', ''),
                    condition: 'contain'
                });
        }
        return paramsFilter;
    }

    private createNewPaymentRequest() {
        if(this.numberOfOrder === 0) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Bạn chưa có đơn hàng nào về HN. Hãy chờ thêm lô hàng sau nhé.',
            });
            return;
        }
        const routeData = this.$router.resolve({ name: 'payment-request-new' });
        window.open(routeData.href, '_blank');
    }

    private onChangePage(data: any) {
        this.pageSettings.pageIndex = data;
        this.loadData();
    }

    private onFilterChanged(data: any) {
        this.filterProp.searchText = data.searchText;
        this.pageSettings.pageIndex = 1;
        this.loadData();
    }
}
